interface EmoteData {
  id: string;
  name: string;
  images: {
    url_1x: string;
    url_2x: string;
    url_4x: string;
  };
  emote_type?: string;
  emote_set_id?: string;
  owner_id?: string;
}

export class TwitchEmoteService {
  private emotes: Map<string, EmoteData> = new Map();
  private clientId: string;
  private accessToken: string;

  constructor(clientId: string, accessToken: string) {
    this.clientId = clientId;
    this.accessToken = accessToken;
  }

  private async fetchWithAuth(url: string): Promise<any> {
    const response = await fetch(url, {
      headers: {
        'Client-ID': this.clientId,
        'Authorization': `Bearer ${this.accessToken}`
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  public async fetchGlobalEmotes(): Promise<EmoteData[]> {
    try {
      const data = await this.fetchWithAuth('https://api.twitch.tv/helix/chat/emotes/global');
      const globalEmotes = data.data.map((emote: any) => ({
        id: emote.id,
        name: emote.name,
        images: {
          url_1x: emote.images.url_1x,
          url_2x: emote.images.url_2x,
          url_4x: emote.images.url_4x
        },
        emote_type: 'global'
      }));

      globalEmotes.forEach((emote: EmoteData) => {
        this.emotes.set(emote.name, emote);
      });

      return globalEmotes;
    } catch (error) {
      console.error('Error fetching global emotes:', error);
      return [];
    }
  }

  public async fetchChannelEmotes(broadcasterId: string): Promise<EmoteData[]> {
    try {
      const data = await this.fetchWithAuth(`https://api.twitch.tv/helix/chat/emotes?broadcaster_id=${broadcasterId}`);
      const channelEmotes = data.data.map((emote: any) => ({
        id: emote.id,
        name: emote.name,
        images: {
          url_1x: emote.images.url_1x,
          url_2x: emote.images.url_2x,
          url_4x: emote.images.url_4x
        },
        emote_type: 'channel',
        owner_id: broadcasterId
      }));

      channelEmotes.forEach((emote: EmoteData) => {
        this.emotes.set(emote.name, emote);
      });

      return channelEmotes;
    } catch (error) {
      console.error('Error fetching channel emotes:', error);
      return [];
    }
  }

  public getEmote(emoteName: string): EmoteData | undefined {
    return this.emotes.get(emoteName);
  }

  public getAllEmotes(): EmoteData[] {
    return Array.from(this.emotes.values());
  }
}
